import Image from "next/image";
import Link from "next/link";
import React from "react";

interface WhatsAppFabProps {
  href?: string;
}

export default function WhatsAppFab({
  href = "https://wa.me/918310516103",
}: WhatsAppFabProps): React.ReactNode {
  return (
    <aside aria-label="Chat on WhatsApp">
      <Link
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
        className="fixed bottom-4 right-4 z-50 cursor-pointer rounded-full bg-[#4ecb5c] p-3 text-white shadow-xl transition-transform hover:scale-110 md:bottom-10 md:right-10"
      >
        <Image src="/icons/whatsapp.png" alt="WhatsApp" width={24} height={24} />
      </Link>
    </aside>
  );
}
